import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import CurrentAccountShow from './CurrentAccountShow';
import LoadingCard from 'components/loading/LoadingCard';
import { fetchCurrentAccount } from 'store/actions/accounts/fetchCurrentAccount';
import { connect } from 'react-redux';
import utils from 'helpers/utils';
class CurrentAccountShowContainer extends React.Component {
    componentDidMount() {
        this.props.fetch();
    }

    render() {
        const {
            data,
            history,
            resource,
            loading,
        } = this.props;

        if (loading && utils.isEmpty(data)) {
            return <LoadingCard />;
        }

        if (utils.isEmpty(data)) {
            return null;
        }

        return <CurrentAccountShow
            history={ history }
            record={ data }
            resource={ resource }
        />;
    }
}

CurrentAccountShowContainer.propTypes = {
    data: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, props) => {
    const { resource } = props;

    return {
        loading: state[resource].loading,
        data: state[resource].data,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: () => {
            dispatch(fetchCurrentAccount());
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(CurrentAccountShowContainer);



// WEBPACK FOOTER //
// ./src/pages/accounts/current-account/show/CurrentAccountShowContainer.js